import React from "react";
import { t } from "i18next";

const TABS = [
    { key: "agroland",   label: () => t("appTitle") },
    { key: "promotions", label: () => t("promotions") },
];

export function NotifFilterTabButtons({ tab, setTab }) {
    return (
        <div className="flex gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden py-0.5">
            {TABS.map(({ key, label }) => (
                <button
                    key={key}
                    type="button"
                    onClick={() => setTab(key)}
                    className={[
                        "h-9 px-5 rounded-full text-sm font-semibold whitespace-nowrap shrink-0",
                        "transition-all duration-150 border cursor-pointer outline-none",
                        tab === key
                            ? "bg-[#147F26] text-white border-[#147F26] shadow-[0_2px_8px_rgba(20,127,38,0.25)]"
                            : "bg-white text-[#222222] border-[#EDEDED] hover:border-[#147F26] hover:text-[#147F26]",
                    ].join(" ")}
                >
                    {label()}
                </button>
            ))}
        </div>
    );
}
